<template>
    <div>
        <div class="gupiao-tu" :style="{'height': tableHeight}">
            <transition name="slide">
                <div class="gu-lt-box" v-if="!hideLeft">
                    <div class="gu-lt-th">自选股</div>
                    <div class="gu-lt-tbox">
                        <template v-if="ziDataList && ziDataList.length">
                            <virtual-list :size="47"
                                          :headerTags="ziHeaders"
                                          rclass="rclass"
                                          wclass="wclass"
                                          :resettdw="false"
                                          hclass="gu-tbox-th"
                                          :onscroll="onscrollIng"
                                          :debounce="1"
                                          ref="virtualList"
                                          :remain="remains || 0">
                                <template v-for="item in ziDataList">
                                    <template v-if="gpDataList && gpDataList.hasOwnProperty(item)">
                                        <div class="gu-tbox-tb2"
                                             @click="setNowDetailCode(item)"
                                             :key="item">
                                            <div class="gu-tbox-tw">
                                                <div class="gu-tbox-tw1">{{gpDataList[item].name}}</div>
                                                <div class="gu-tbox-tw2">{{item}}</div>
                                            </div>
                                            <div class="gu-tbox-t"
                                                 :class="{
                                                     'red': +gpDataList[item].gain > 0,
                                                     'green': +gpDataList[item].gain < 0
                                                 }">{{gpDataList[item].latestPrice}}
                                            </div>
                                            <div class="gu-tbox-t"
                                                 :class="{
                                                     'red': +gpDataList[item].gain > 0,
                                                     'green': +gpDataList[item].gain < 0
                                                 }">{{gpDataList[item].gain}}%
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </virtual-list>
                        </template>
                        <template v-else>
                            <div class="emptyZixuan">暂无自选股票</div>
                        </template>
                    </div>
                </div>
            </transition>
            <div class="gu-cnt-box">
                <div class="gu-lt-th">
                    <div class="gu-lt-img" @click="hideLeft = !hideLeft"><img src="~@/assets/images/zhankai1@3x.png"/>
                    </div>
                    <div class="gu-lt-img" @click="reback()"><img src="~@/assets/images/back@3x.png"/></div>
                    <div class="span-t"
                         @click="setNowTag(tag)"
                         :class="{'yellow': tag[1] === nowTag[1]}"
                         v-for="tag in tags" :key="tag[1]">{{tag[0]}}
                    </div>
                    <div class="gu-lt-img flot" @click="hideRight = !hideRight"><img
                            src="~@/assets/images/zhankai2@3x.png"/>
                    </div>
                </div>
                <div class="gu-cnt-th">
                    <span class="font">{{detailData.name}} {{nowTag[0]}}</span>
                    <span>最新 {{detailData.latestPrice}}</span>
                    <span class="green" v-if="nowTag[1] === 'minute'">均价 {{minuteAvePrice}}</span>
                </div>
                <div class="control" v-if="nowTag[1] !== 'minute' && showCtrl < 100 ">
                    <span @click="setDataZoom(-1)"></span>
                    <span @click="setDataZoom(1)"></span>
                </div>
                <div id="Kline-div" class="Kline-div">
                    <div id="k-content" class="K-line"></div>
                </div>
            </div>

            <transition name="slide">
                <div class="gupiao-tu-rt" v-if="!hideRight">
                    <div class="gupiao-rt-h">
                        <div class="gupiao-name">{{detailData.name}}<span>{{detailData.symbol}}</span></div>
                        <div class="gu-love"
                             @click="setZixuan()"
                             :class="{'active': isZixuan}"
                             :title="isZixuan ? '删除自选': '加入自选'"></div>
                        <div class="gupiao-name2" :class="{'red': detailData.gain > 0, 'green': detailData.gain < 0}">
                            <div class="gupiao-n-lt">{{detailData.latestPrice}}</div>
                            <div class="gupiao-n-rt">
                                <div class="gupiao-tt">{{detailData.gainValue}}</div>
                                <div class="gupiao-tt">{{detailData.gain}}%</div>
                            </div>
                        </div>
                    </div>
                    <div class="gu-shuju-box">
                        <div class="gu-shuju">
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">昨收</div>
                                <div class="gu-shu-t2">{{detailData.preClose}}</div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">今开</div>
                                <div class="gu-shu-t2"
                                     :class="{'red': +detailData.open > +detailData.preClose,
                                     'green': +detailData.open < +detailData.preClose}">{{detailData.open}}
                                </div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">最高</div>
                                <div class="gu-shu-t2"
                                     :class="{'red': +detailData.high > +detailData.preClose,
                                     'green': +detailData.high < +detailData.preClose}">{{detailData.high}}
                                </div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">总量</div>
                                <div class="gu-shu-t2">{{detailData.volume}}</div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">最低</div>
                                <div class="gu-shu-t2"
                                     :class="{'red': +detailData.low > +detailData.preClose,
                                     'green': +detailData.low < +detailData.preClose}">{{detailData.low}}
                                </div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">市盈率</div>
                                <div class="gu-shu-t2">{{detailData.pe}}</div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">总市值</div>
                                <div class="gu-shu-t2">{{detailData.totalMarketValue}}</div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">市净率</div>
                                <div class="gu-shu-t2">{{detailData.pb}}</div>
                            </div>

                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">涨停</div>
                                <div class="gu-shu-t2 red">{{detailData.limitUpValue}}</div>
                            </div>
                            <div class="gu-shu-tb">
                                <div class="gu-shu-t1">跌停</div>
                                <div class="gu-shu-t2 green">{{detailData.limitDownValue}}</div>
                            </div>
                        </div>
                        <div class="gu-shuju" v-for="box in 2" :key="box">
                            <div class="gu-shu-tb wid" v-for="item in dangci[box - 1]" :key="item">
                                <div class="gu-shu-t1">{{box === 1 ? '卖':'买'}}{{item}}</div>
                                <div class="gu-shu-t2" :class="getColor(box, item)">{{getPri(box, item)}}</div>
                                <div class="gu-shu-t1">{{detailData[(box === 1 ? 'sell':'buy') + enNum[item - 1]]}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import KLine from './k-line'
    import DetailPageApi from './DetailPageApi'
    import virtualList from '../../component/VirtualList.js'

    export default {
        name: "DetailPage",
        components: {'virtual-list': virtualList},
        data: function () {
            return {
                hideLeft: false,
                hideRight: false,
                detailCode: null, // 分时图个股的code
                types: null,
                kChart: null,
                tags: Object.freeze([['分时', 'minute'], ['日线', 'day'], ['周线', 'week'], ['月线', 'month']]),
                nowTag: null,
                kdata: null,
                mdata: null,
                mkTimeOutHand: null, // 分时和K线的更新时间句柄
                minuteAvePrice: 0, // 分时图的均价
                ziHeaders: Object.freeze([['股票代码', 'code'], ['最新价', 'latestPrice'], ['涨跌幅↑', 'gain']]),
                ziUpdateTimeOutHand: null,
                scrollStart: 0, // 自选列表滚动开始位置，默认是0
                isZixuan: false,
                enNum: Object.freeze(['One', 'Two', 'Three', 'Four', 'Five']),
                dangci: Object.freeze([[5, 4, 3, 2, 1], 5]),
                showCtrl: 80,
                tableHeight: window.innerHeight - (this.$store.state.hideFooter ? 76 : 401) + 'px'
            }
        },
        created() {
            this.detailCode = localStorage.getItem('now_gp');
            try {
                this.nowTag = JSON.parse(localStorage.getItem('nowTag')) || this.tags[0];
            } catch (e) {
                this.nowTag = this.tags[0];
                localStorage.removeItem('nowTag')
            }
            this.initDetail(this.detailCode);
        },
        computed: {
            detailData: function () {
                if (this.$route.params.type === 1) {
                    return this.$store.state.now_chois_dp_item;
                } else {
                    return this.$store.state.now_chois_gp_item || {
                        buyFive: '-',
                        buyFivePri: '-',
                        buyFour: '-',
                        buyFourPri: '-',
                        buyOne: '-',
                        buyOnePri: '-',
                        buyThree: '-',
                        buyThreePri: '-',
                        buyTwo: '-',
                        buyTwoPri: '-',
                        sellFive: '-',
                        sellFivePri: '-',
                        sellFour: '-',
                        sellFourPri: '-',
                        sellOne: '-',
                        sellOnePri: '-',
                        sellThree: '-',
                        sellThreePri: '-',
                        sellTwo: '-',
                        sellTwoPri: '-'
                    };
                }
            },
            // 自选股列表
            ziDataList: function () {
                if (this.$store.state.gp_keys_zi) {
                    this.updataZixListDetail(0, Math.ceil(this.remains * 2));
                    return this.$store.state.gp_keys_zi;
                }
                return null;
            },
            // 所有股票列表
            gpDataList: function () {
                if (this.$store.state.gupiaolist_sz) {
                    return this.$store.state.gupiaolist_sz.entities.patrons;
                }
                return null;
            },
            remains: function () {
                const remains = (parseInt(this.tableHeight) - 47) / 47;
                this.$forceUpdate();
                return remains;
            },
            isopen() {
                return this.$store.state.isopen;
            }
        },
        watch: {
            isopen(v) {
                if (v) {
                    this.initDetail(this.detailCode);
                }
            },
            '$route': function (to) {
                this.types = to.params.type;
                if (this.types === 1) {
                    this.$store.commit('SET_FOUCS_DP', this.detailCode);
                } else {
                    this.$store.commit('SET_FOUCS_GP', this.detailCode);
                }
            },
            '$store.state.hideFooterTime'() {
                this.tableHeight = window.innerHeight - (this.$store.state.hideFooter ? 76 : 401) + 'px';
            },
            detailData: function (val, oval) {
                if (val.code !== oval.code) {
                    this.detailCode = val.code;
                    // 如果没有个股的最高和最低以及昨日收盘价，分时图会不完整
                    this.initDetail(val.code);
                }
            },
            tableHeight: function () {
                // 页面高度变了，重新画图
                this.drawLine(true);
            },
            hideLeft: function () {
                this.drawLine(true);
            },
            hideRight: function () {
                this.drawLine(true);
            },
            nowTag: function (value, oval) {
                // 更新分时图或者k线
                if (value) {
                    localStorage.setItem('nowTag', JSON.stringify(value));
                    this.get_MinuteOrKLine(true);
                }
                if ((oval && value[1] !== oval[1]) && this.kChart) {
                    this.kChart.clear();
                }
                window.requestAnimationFrame(function () {
                    this.drawLine();
                }.bind(this))
            },
            mdata: function (value) {
                if (value !== null && value.hasOwnProperty('line')
                    && value.line.hasOwnProperty('intraday')
                    && value.line.intraday.hasOwnProperty('items')) {
                    const arr_ = value.line.intraday.items[0];
                    this.minuteAvePrice = arr_[arr_.length - 1].avgPrice;
                    const f__ = () => {
                        // 个股详细数据不完整，画图也不完整，等完整再画
                        if (this.detailData.preClose) {
                            this.drawLine();
                        } else {
                            window.requestAnimationFrame(function () {
                                this.drawLine();
                            }.bind(this))
                        }
                    };
                    window.requestAnimationFrame(function () {
                        f__();
                    })
                }
            },
            kdata: function () {
                this.drawLine();
            },
            ziDataList: function (value, ovalue) {
                if (value.toString() !== ovalue.toString()) {
                    // 推送自选的行情
                    this.updataZixListDetail(0, Math.ceil(this.remains * 2));
                    this.$store.commit('UPDATE_SOCKET_IDS', {code_s: this.$store.state.gp_keys_zi, t: 'gpList'});
                }
            }
        },
        beforeDestroy() {
            if (this.mkTimeOutHand) {
                clearTimeout(this.mkTimeOutHand);
            }
            this.$store.commit('UPDATE_SOCKET_IDS', {code_s: [], t: 'detail'});
        },
        methods: {
            getColor(box, item) {
                return {
                    'red': this.getPri(box, item) > this.detailData.preClose,
                    'green': this.getPri(box, item) < this.detailData.preClose,
                }
            },
            getPri(box, item) {
                return this.detailData[(box === 1 ? 'sell' : 'buy') + this.enNum[item - 1] + 'Pri']
            },
            reback() {
                this.$router.go(-1)
            },
            drawLine(resize) {
                if (this.nowTag[1] === 'minute' && !this.mdata) {
                    return false;
                } else if (this.nowTag[1] !== 'minute' && !this.kdata) {
                    return false;
                }
                if (!this.kChart) {
                    this.kChart = this.$echarts.init(document.getElementById('k-content'));
                    this.kChart.on('datazoom', function (params) {
                        if (params.hasOwnProperty('batch'))
                            this.showCtrl = params.batch[0].end - params.batch[0].start;
                    }.bind(this));
                }
                if (resize) {
                    setTimeout(() => {
                        this.kChart.resize();
                    }, 300);
                } else {
                    if (this.nowTag[1] === 'minute') {
                        this.kChart.setOption(KLine.initMOption(this.mdata.line.intraday, this.detailData));
                    } else {
                        this.kChart.setOption(KLine.initKOption(this.kdata.line.items[0], this.nowTag[1], this.detailData));
                    }
                }
            },
            setNowTag(tag) {
                this.nowTag = tag;
            },
            ...DetailPageApi,
            onscrollIng(event, data) {
                if (this.scrollStart !== data.start) {
                    this.scrollStart = data.start;
                    this.updataZixListDetail(data.start, data.end);
                }
            },
            updataZixListDetail(start, end) {
                if (this.ziUpdateTimeOutHand) {
                    clearTimeout(this.ziUpdateTimeOutHand);
                }
                // timeout是scroll节流，防止每次滚动事件触发都频繁请求，只有滚动停止300ms后才请求
                this.ziUpdateTimeOutHand = setTimeout(() => {
                    const arr = this.ziDataList.slice(start, end);
                    this.$api.getGpDetail(arr.join(',')).then(res => {
                        // 把数据扔给vuex处理
                        if (res.data.code === 1) {
                            this.$store.commit('UPDATE_GP_DETAIL', {data: res.data.data});
                        }
                    })
                }, 300)
            },
            setNowDetailCode(item) {
                this.detailCode = item;
                localStorage.setItem('now_gp', item);
                this.$store.commit('SET_FOUCS_GP', item);
            },
            initDetail(detailCode) {
                return new Promise(resolve => {
                    this.types = this.$route.params.type;
                    if (!detailCode) {
                        this.$router.go(-1);
                    } else {
                        // 更新当前个股行情到列表
                        try {
                            if (!!this.$store.state.gupiaolist_sz.entities.patrons) {
                                this.$api.getGpDetail(detailCode).then(res => {
                                    console.log('更新当前个股行情到列表', res);
                                    if (res.data.code === 1) {
                                        this.$store.commit('UPDATE_GP_DETAIL', {data: res.data.data});
                                        this.$store.commit('UPDATE_SOCKET_IDS', {code_s: [detailCode], t: 'detail'});
                                    }
                                    if (this.types === 1) {
                                        this.$store.commit('SET_FOUCS_DP', detailCode);
                                    } else {
                                        this.$store.commit('SET_FOUCS_GP', detailCode);
                                    }
                                    this.get_MinuteOrKLine(true);
                                    // 检查是否自选股
                                    this.$api.judgeChooseCtock(this.$store.state.now_token, this.$store.state.now_trade_account, detailCode).then(res => {
                                        this.isZixuan = res.data.code === 200 && res.data.data.code === 1;
                                    });
                                    resolve(true);
                                });
                            } else {
                                window.requestAnimationFrame(() => {
                                    this.initDetail(detailCode)
                                })
                            }
                        } catch (e) {
                            window.requestAnimationFrame(() => {
                                this.initDetail(detailCode)
                            })
                        }

                    }
                })
            },
            setZixuan() {
                if (!this.isZixuan) {
                    this.$api.addChooseStock(this.$store.state.now_token, this.$store.state.now_trade_account, this.detailCode, this.detailData.name).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                message: res.data.data,
                                type: 'success'
                            });
                            this.isZixuan = true;
                            this.$store.commit('UP_ZIXUAN', Math.random() * 999999);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                } else {
                    this.$api.deleteChooseStock(this.$store.state.now_token, this.$store.state.now_trade_account, this.detailCode).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                message: res.data.data,
                                type: 'success'
                            });
                            this.isZixuan = false;
                            this.$store.commit('UP_ZIXUAN', Math.random() * 999999);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                }
            },
            setDataZoom(lr) {
                if (this.kChart) {
                    const dataZoom = this.kChart.getOption().dataZoom[0];
                    if (lr < 0) {
                        if (dataZoom.start > 0) {
                            this.kChart.dispatchAction({
                                type: 'dataZoom',
                                start: Math.max(dataZoom.start - 1, 0),
                                end: dataZoom.end - 1
                            });
                        }
                    } else {
                        if (dataZoom.end < 100) {
                            this.kChart.dispatchAction({
                                type: 'dataZoom',
                                start: dataZoom.start + 1,
                                end: Math.min(dataZoom.end + 1, 100)
                            });
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "DetailPage.scss";
</style>
